<template>
    <div class="mobile">
        <TheHeader class="mob-header" />
        <div class="nav-page clearfix">
            <div class="nav-page-title">喜得</div>
            <div class="nav-page-list clearfix">
                <router-link 
                    class="nav-page-list-item" 
                    to="/example"
                >
                    案例
                </router-link>
                <router-link 
                    class="nav-page-list-item" 
                    to="/product"
                >
                    产品
                </router-link>
                <router-link 
                    class="nav-page-list-item" 
                    to="/method"
                >
                    方法
                </router-link>
                <router-link 
                    class="nav-page-list-item" 
                    to="/industry-experience"
                >
                    行业经验
                </router-link>
            </div>
        </div>

        <SwiperImagesFreeX 
            class="banner" 
            :exampleList="exampleList" 
        />

        <div class="list-aboutus">
            <div class="title">关于我们</div>
          
            <div class="box">
                <p class="list-aboutus_text">我们作为体验设计/服务设计提供商，帮助企业全面提升与客户的数字化互动体验。 </p>
                <p class="list-aboutus_text">喜得认为，要真正赢得客户的感动与满意，在应用更多技术的同时，也需要更多用心的设计，两者平衡才体现真正的智慧，从而在市场中脱颖而出。</p>
                <router-link 
                        class="list-aboutus_btn" 
                        to="/aboutus">
                    关于我们
                </router-link>
            </div>
        </div>

        <div class="service">
            <div class="title">我们的服务</div>
            
            <div class="service-list">
                <router-link 
                    class="service-list-item" 
                    to="/service"
                >设计与实施</router-link>
                <router-link 
                    class="service-list-item" 
                    to="/service"
                >咨询与设计</router-link>
                <router-link
                    class="service-list-item" 
                    to="/service"
                >设计与开发</router-link>
            </div>
            <img class="service_bg" :src="'./images/index/mob/service-bg.png'">
            <router-link class="service_btn" to="/service">我们的服务</router-link>
        </div>

        <div class="contact">
            <div class="title">
                心动而喜 满意而得<br>
                我们期待与您的合作！
            </div>
            <img class="contact-code" src="@/assets/images/contact_ma.png">
            <BaseAddress class="mob-index-address"/>
            <img class="contact_bg" :src="'./images/index/mob/contact_bg.jpg'">
        </div>
        <TheFooter class="mob-the-footer-index" />
    </div>
</template>
<script>
    import TheHeader from '@/components/module/TheHeader'
    import TheFooter from '@/components/module/TheFooter'
    import '@/assets/less/module/module-the-header_mob-header.less'
    import '@/assets/less/module/module-the-footer-index_mob-the-footer-index.less'

    import BaseAddress from '@/components/module/BaseAddress'
    import SwiperImagesFreeX from '@/components/module/SwiperImagesFreeX'

    import '@/assets/less/module/module-base-address_index-address.less'
    import '@/assets/less/module/module-mob-index_mob-index.less'

    export default {
        name: 'MobIndex',
        props: {
            exampleList: Array
        },
        data: function(){
            return {

            }
        },       
        components: {
            TheHeader,
            TheFooter,
            BaseAddress,
            SwiperImagesFreeX
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*导航*/

</style>